import React from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'
import { StructureLogoOrGeneric } from '../../../components/StructureLogoOrGeneric'
import { Dayjs } from 'dayjs'
import { MatchStatus } from '../../../utils/statsperform/types'
import { LiveMatchStatus } from '../../../components/LiveMatchStatus'

type Team = {
    name: string
    score: number | undefined | null
    icon?: string
}

type HomeTeam = {
    [K in keyof Team as `home${Capitalize<K>}`]: Team[K]
}

type AwayTeam = {
    [K in keyof Team as `away${Capitalize<K>}`]: Team[K]
}

type LiveMatchItemProps = {
    href: string
    title: string
    error?: boolean
    loading?: boolean
    status: MatchStatus
    date: Dayjs
    className?: string
} & HomeTeam &
    AwayTeam

export const LiveMatchItem = ({
    href,
    title,
    error,
    loading,
    homeName,
    homeScore,
    homeIcon,
    awayName,
    awayScore,
    awayIcon,
    date,
    status,
    className,
}: LiveMatchItemProps) => {
    return (
        <a
            href={href}
            className={clsx(styles.component, className, loading && styles.loading)}
            title={title}
        >
            {error ? (
                <div
                    className={styles.error}
                    title="Erreur de synchro, veuilliez rafraîchir le site."
                >
                    ⚠️
                </div>
            ) : null}

            <div className={styles.prompt}>
                <LiveMatchStatus status={status} date={date} />
            </div>

            <div className={styles.title}>{title}</div>

            <div className={styles.scores}>
                <div className={clsx(styles.team, styles.home)}>
                    <span className={styles.name}>{homeName}</span>
                    <StructureLogoOrGeneric
                        imageUrl={homeIcon}
                        className={styles.icon}
                        title={`Drapeau ${homeName}`}
                    />
                    <span className={styles.score}>{homeScore ?? '_'}</span>
                </div>

                <span>-</span>

                <div className={clsx(styles.team, styles.away)}>
                    <span className={styles.score}>{awayScore ?? '_'}</span>
                    <StructureLogoOrGeneric
                        imageUrl={awayIcon}
                        className={styles.icon}
                        title={`Drapeau ${awayName}`}
                    />
                    <span className={styles.name}>{awayName}</span>
                </div>
            </div>
        </a>
    )
}
